import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectTopicsState } from "../store/topics/selectors";
import { selectSelectedTenantId } from "../store/user/selectors";
import { getTopicsByTenantId } from "../store/topics/thunks";

export const useTenantTopics = ({ selectedBranchId = null, fetch = false }) => {
  const dispatch = useDispatch();
  const selectedTenantId = useSelector(selectSelectedTenantId);
  const { topicsByTenants, loading } = useSelector(selectTopicsState);

  useEffect(() => {
    if (selectedTenantId && !topicsByTenants?.[selectedTenantId] && fetch) {
      dispatch(
        getTopicsByTenantId({
          tenant_id: selectedTenantId,
        }),
      );
    }
  }, [selectedTenantId, topicsByTenants, fetch]);

  const topics = useMemo(() => {
    return topicsByTenants[selectedTenantId] || [];
  }, [topicsByTenants, selectedTenantId]);

  const topicsOptions = useMemo(() => {
    if (!selectedBranchId) return [];
    return (
      topics?.filter((t) => t?.branch_ids?.includes(selectedBranchId)) || []
    ).map(({ name, id }) => ({ label: name, value: id }));
  }, [topics, selectedBranchId]);

  return { topics, loading, selectedTenantId, topicsOptions };
};
